export enum ChatRoomTypes {
    general = 'general',
    culture = 'culture',
    relationships = 'relationships',
    sports = 'sports',
}
